import * as React from 'react';
import { BaseBlockView } from '../base-block.view';
import styled, { css } from 'styled-components';
import { DraftToHtml } from '../../draft-to-html/draft-to-html';
import { getCenterOfPageStyle } from '../../../util/style/get-center-of-page-style';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../interface/component/injected-props.interface';
import { RepeatingTextBlockModel } from '../../../model/block';
import { isDraftEmpty } from '../../../util/draft/is-draft-empty.util';
import { findLinkedDataById } from '../../../util/page/find-linked-data-by-id.util';
import { findLinkedData } from '../../../util/page/find-linked-data.util';
import { getLinkFinalURL } from '../../../util/url/get-link-final-url';
import { formLinkFromTemplate } from '../../../util/url/form-link-from-template';
import { SmartLink } from '../../smart-link/smart-link';

const textBlockWrapperStyle = css`
  padding: 20px 13px;
  word-wrap: break-word;
`;

const TextBlockWrapperLink = styled(SmartLink)`
  display: block;
  ${textBlockWrapperStyle}
`;

const TextBlockWrapper = styled.div`
  ${textBlockWrapperStyle}
`;

const CenterViewWrapper = styled.div`
  padding-top: 30px;
  padding-bottom: 30px;
  ${getCenterOfPageStyle()}
`;

@inject('state')
@observer
export class RepeatingTextBlockView extends BaseBlockView<RepeatingTextBlockModel, IInjectedProps> {
  render() {
    const mentions = this.props.content.getUsedMentions(this.props.state.activeDesign.data);
    const hasContent = mentions.length === 0 ? !isDraftEmpty(this.props.content.text) : mentions.some((mention) => {
      const linkedData = findLinkedDataById(mention, this.props.state.activeDesign.data);
      return linkedData && linkedData.data !== null && linkedData.data !== undefined;
    });
    if (!hasContent && !this.props.inEditor) {
      return null;
    }
    const {content} = this.props;
    const selectedMention = content.selectedMention;
    if (!selectedMention) {
      return <div>
        No content data found...
      </div>;
    }
    const foundData = findLinkedData(selectedMention, this.props.state.activeDesign.data);
    if (!foundData) {
      return null;
    }
    const data = (foundData.data || []);
    if (this.props.inEditor) {
      data.push({});
    }
    const Wrapper: any = this.props.content.detailsLinkTemplate && this.props.content.detailsLinkTemplate.mention ? TextBlockWrapperLink : TextBlockWrapper;
    return (
      <CenterViewWrapper data-type="CenterViewWrapper">
        {
          data.map((blockMentionData, index) => {
            return <Wrapper
              key={index}
              to={getLinkFinalURL(this.props.state, formLinkFromTemplate(this.props.content.detailsLinkTemplate, String(blockMentionData.id)), blockMentionData, true)}
            >
              <DraftToHtml
                draft={this.props.content.text}
                blockMentionData={blockMentionData}
                inEditor={this.props.inEditor}
              />
            </Wrapper>;
          })
        }
      </CenterViewWrapper>
    );
  }
}
